import { connect, useDispatch } from "react-redux";
import {
  changeUserAvatar,
  resetChangeUserAvatar,
} from "./../../../../../store/actions/user";
import Snackbar from "../../../../../components/Snackbar";
import { SectionTitle, Button, Section } from "../../styles";
import { Form } from "./styles";
import AvatarEditor from "../../../../../components/Form/AvatarEditor";
import { useForm } from "react-hook-form";
import { useEffect, useState, useRef, useMemo } from "react";
import { hideModal } from "../../../../../store/actions/modal";

const Component = ({ changeUserAvatarStates, userInformation }) => {
  const dispatch = useDispatch();
  const [profilePic, setProfilePic] = useState();
  const ref = useRef<HTMLFormElement>();

  const onFormSubmit = (data) => {
    dispatch(changeUserAvatar({ ...data, userId: userInformation?.id }));
  };

  const onFormError = (data) => { };

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onSubmit",
  });

  useEffect(() => {
    if (userInformation?.profile_pic) {
      setProfilePic(userInformation?.profile_pic.url);
    }
  }, [userInformation]);

  useEffect(() => {
    if (changeUserAvatarStates.success) {
      setTimeout(() => {
        dispatch(resetChangeUserAvatar());
      }, 3000);
    }
  }, [changeUserAvatarStates]);

  return (
    <Section>
      <SectionTitle>Foto de perfil</SectionTitle>

      <div style={{ height: 12 }} />

      <Form
        onSubmit={handleSubmit(onFormSubmit, onFormError)}
        id="change-avatar"
        ref={ref}
      >
        <AvatarEditor
          onSave={() => {
            ref.current?.dispatchEvent(
              new Event("submit", { cancelable: true, bubbles: true })
            );
          }}
          name="profile_pic"
          setValue={setValue}
          picture={profilePic}
          register={register}
          loading={changeUserAvatarStates.loading}
          errors={{ ...errors }}
        />
      </Form>
    </Section>
  );
};

const state = ({ userStore }) => {
  const { data: userInformation } = userStore.information;
  const { states: changeUserAvatarStates } = userStore.changeUserAvatar;
  return {
    userInformation,
    changeUserAvatarStates,
  };
};

export default connect(state)(Component);
